import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { catchError, map, of } from 'rxjs';
import { UserHttpService } from '../services/user.http.service';

export const verifyGuard: CanActivateFn = () => {
  const router = inject(Router);
  const httpService = inject(UserHttpService);
  const isVerified = (user: any) => {
    const verified = user?.verified;
    return verified === true || verified === 'true' || verified === 1 || verified === '1';
  };

  if (httpService.isCurrentUserVerified()) {
    return true;
  }

  return httpService.getCurrentUser().pipe(
    map((user) => isVerified(user) ? true : router.createUrlTree(['/verify'])),
    catchError(() => of(router.createUrlTree(['/login']))),
  );
};
